import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavController } from "ionic-angular";

@Component({
    selector: 'team-settings',
    templateUrl: 'team-settings.html'
})

export class TeamSettingsComponent {
    counters = [
        {
            name: this.translate.instant('encounter'),
            value: 0
        },
        {
            name: this.translate.instant('winscore'),
            value: 0
        },
        {
            name: this.translate.instant('tiescore'),
            value: 0
        },
        {
            name: this.translate.instant('lossscore'),
            value: 0
        }
    ]

    constructor(
        private navCtrl: NavController,
        private translate: TranslateService
        ){
        
    }

    onBackMenu(){
        this.navCtrl.pop()
    }
}


// WEBPACK FOOTER //
// /src/components/team-settings/team-settings.ts